import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/apiAuth'
import './assets/fonts/sukhumvit.css'
import './assets/styles/app.css'
import { applyMotionClass, ensureSettings } from './fun/settings'

Vue.config.productionTip = false

// เปิด/ปิดแอนิเมชันทั้งระบบตามการตั้งค่า (และค่า "ลดการเคลื่อนไหว" ของเครื่อง)
// ใช้ค่าที่เก็บไว้ก่อน แล้วโหลดการตั้งค่าล่าสุดของระบบจาก backend
applyMotionClass()
ensureSettings()

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
